<template>
  <div>
  <v-row justify="center" no-gutters align="center" style="width: 100%;min-height:400px;background-image: url('img/karte.png');background-size:cover;background-position: center">
    <v-col style="text-align: center;" v-if="supported">
      <img alt="playButton" v-if="!initialized" :src="require('@/assets/DSM_IntoxicatingSpaces_play_button_2x.png')" style="max-width:50%;cursor:pointer" :class="loading?'rotating':''" @click="loadScripts" />
      <div v-if="showMap" id="unityContainer" style="position:absolute;left:-20000px"></div>
      <v-btn @click="fullScreen" v-if="initialized" tile color="isYellow">Start</v-btn>
    </v-col>
    <v-col style="text-align: center;" v-if="!supported">
      <v-alert
        dense
        type="error"
      >
        {{lang==='de'?'Leider wird die Karte auf diesem Gerät nicht unterstützt.':'Sorry, this device is not supported.'}}
    </v-alert>
    </v-col>
  </v-row>
    <v-row justify="center" no-gutters style="width: 100%;margin-top:5px;">
      <v-col>
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>
<style>
@-webkit-keyframes rotating {
  from{
      -webkit-transform: rotate(0deg);
  }
  to{
      -webkit-transform: rotate(360deg);
  }
}

.rotating {
  -webkit-animation: rotating 2s linear infinite;
}
</style>
<script>
export default {
  name: 'InteractiveMap',
  props: {
    lang: String
  },
  data () {
    return {
      showMap: false,
      loaded: 0,
      initialized: false,
      unity: null,
      loading: false,
      supported: true
    }
  },
  methods: {
    fullScreen () {
      this.unity.SetFullscreen(1)
      this.initialized = false
    },
    initMap () {
      // console.log("ready to init map");
      const that = this
      that.supported = !UnityLoader.SystemInfo.mobile
      if (that.supported) {
        that.unity = UnityLoader.instantiate('unityContainer', 'Karte_Html/Build/Karte_Html_1.3.json', {
          onProgress: UnityProgress,
          Module: {
            onRuntimeInitialized: function () {
              // eslint ignore
              UnityProgress(unityContainer, 'complete')
              that.initialized = true
              that.loading = false
            }
          }
        })
      } else {
        that.initialized = false
        that.loading = false
      }
    },
    loadScripts () {
      this.loading = true
      this.showMap = true
      if (this.loaded === 0) {
        this.$loadScript('Karte_Html/TemplateData/UnityProgress.js')
          .then(() => {
          // Script is loaded, do something
            this.loaded++
            if (this.loaded === 2) {
              this.initMap()
            }
          })
          .catch((er) => {
          // Failed to fetch script
            console.error(er)
          })
        this.$loadScript('Karte_Html/Build/UnityLoader.js')
          .then(() => {
          // Script is loaded, do something
            this.loaded++
            if (this.loaded === 2) {
              this.initMap()
            }
          })
          .catch((er) => {
          // Failed to fetch script
            console.error(er)
          })
      } else {
        this.initMap()
      }
    }
  }
}
</script>
